import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  STANDARDHISTORY,
  STANDARDHISTORY_FILE_IMPORT,
  STANDARDHISTORY_FILE_IMPORT_FINISHED
} from './standardHistoryActions';

const handleError = (state, action) => {
  const errors =
    action.payload && action.payload.errors ? action.payload.errors || [] : [];

  return updateResourceState(state, action, RESOURCE, () => ({
    saving: false,
    loading: false,
    importingFile: false,
    errors
  }));
};

const standardHistoryReducer = createResourceReducer(
  STANDARDHISTORY,
  [],
  {
    [STANDARDHISTORY_FILE_IMPORT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        importingFile: true
      }));
    },

    [STANDARDHISTORY_FILE_IMPORT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false,
        importingFile: false
      }));
    }
  },
  handleError
);

export default standardHistoryReducer;
